import React from 'react';
import Reveal from './Reveal';

const ADVANTAGES = [
  {
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" />
      </svg>
    ),
    title: 'Product-First Approach',
    desc: 'We build, test & scale our own AI products first — giving every client the benefit of real-world, battle-tested expertise.',
    highlight: 'Battle-tested solutions',
    accent: 'brand-blue',
  },
  {
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4" />
      </svg>
    ),
    title: 'Modern Tech Excellence',
    desc: 'Deep expertise in Java, Python, AI/ML, and full-stack web & mobile development with the latest frameworks and tools.',
    highlight: 'Latest technologies',
    accent: 'brand-purple',
  },
  {
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" />
      </svg>
    ),
    title: 'Consult + Execute',
    desc: 'We don\'t just consult — we execute. Strategy to deployment, we own delivery end-to-end with full accountability.',
    highlight: 'End-to-end delivery',
    accent: 'brand-green',
  },
  {
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
      </svg>
    ),
    title: 'Bangalore Tech Hub',
    desc: "Located in India's Silicon Valley — we leverage a world-class tech ecosystem and deep, diverse talent pool.",
    highlight: 'Prime location',
    accent: 'brand-cyan',
  },
  {
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
      </svg>
    ),
    title: 'Flexible Engagements',
    desc: 'SaaS subscriptions, custom projects, freelance support, or training programs — built around your exact needs and timeline.',
    highlight: 'Your way, your pace',
    accent: 'brand-gold',
  },
  {
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
      </svg>
    ),
    title: 'AI-Innovation Focus',
    desc: 'Specialized in AI & ML solutions that deliver real competitive advantage — future-ready technology built for scale.',
    highlight: 'Future-ready AI',
    accent: 'brand-pink',
  },
];

const TECH_STACK = [
  { name: 'React', cat: 'Frontend' }, { name: 'Node.js', cat: 'Backend' }, { name: 'Python', cat: 'AI/ML' },
  { name: 'Java', cat: 'Enterprise' }, { name: 'TypeScript', cat: 'Full-Stack' }, { name: 'OpenAI', cat: 'Gen AI' },
  { name: 'AWS', cat: 'Cloud' }, { name: 'Docker', cat: 'DevOps' }, { name: 'MongoDB', cat: 'Database' },
  { name: 'PostgreSQL', cat: 'Database' }, { name: 'Flutter', cat: 'Mobile' }, { name: 'Kubernetes', cat: 'Infra' },
];

const STATS = [
  { value: '100+', label: 'Projects Delivered', color: 'brand-blue' },
  { value: '50+', label: 'Happy Clients', color: 'brand-purple' },
  { value: '3+', label: 'Years Experience', color: 'brand-green' },
  { value: '24/7', label: 'Support Available', color: 'brand-gold' },
];

const WhyChoose = () => (
  <section className="section-padding bg-brand-surface relative overflow-hidden scroll-mt-16">
    <div className="absolute top-0 left-0 w-[500px] h-[500px] rounded-full bg-brand-blue/5 blur-[140px] pointer-events-none" />
    <div className="absolute bottom-0 right-0 w-[400px] h-[400px] rounded-full bg-brand-purple/5 blur-[120px] pointer-events-none" />

    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">

      <Reveal from="up" className="section-header">
        <div className="inline-flex items-center gap-2 glass px-4 py-2 rounded-full text-sm font-medium text-brand-green border border-brand-green/20 mb-6">
          <span className="w-1.5 h-1.5 rounded-full bg-brand-green" />
          Why Avarnix
        </div>
        <h2 className="text-4xl md:text-6xl font-black text-brand-text mb-5">
          Why Choose <span className="text-gradient">Us?</span>
        </h2>
        <p className="text-lg text-brand-muted max-w-2xl mx-auto">
          Product expertise, technical depth, and strategic execution — combined to deliver results that actually matter.
        </p>
      </Reveal>

      {/* Stats */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-16">
        {STATS.map((s, i) => (
          <Reveal key={i} from="up" delay={i * 60}>
            <div className={`card text-center hover:border-${s.color}/30 transition-all duration-300 group`}>
              <div className={`text-4xl md:text-5xl font-black text-${s.color} mb-2 group-hover:scale-110 transition-transform`}>{s.value}</div>
              <div className="text-brand-muted text-sm font-medium">{s.label}</div>
            </div>
          </Reveal>
        ))}
      </div>

      {/* Advantages */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 mb-14">
        {ADVANTAGES.map((a, i) => (
          <Reveal key={i} from="up" delay={i * 70}>
            <div className={`card group hover:border-${a.accent}/30 hover:shadow-glow-blue transition-all duration-300 h-full relative overflow-hidden`}>
              <div className={`inline-flex items-center justify-center w-11 h-11 rounded-xl mb-5 bg-${a.accent}/15 text-${a.accent} group-hover:scale-110 transition-transform`}>
                {a.icon}
              </div>
              <h3 className="text-brand-text font-bold text-lg mb-3">{a.title}</h3>
              <p className="text-brand-muted text-sm leading-relaxed mb-5">{a.desc}</p>
              <span className={`inline-flex items-center gap-1.5 text-xs font-semibold px-3 py-1.5 rounded-full bg-${a.accent}/10 text-${a.accent} border border-${a.accent}/20`}>
                <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M5 13l4 4L19 7" />
                </svg>
                {a.highlight}
              </span>
              <div className={`absolute bottom-0 left-0 h-0.5 w-0 bg-gradient-to-r from-${a.accent} to-brand-purple rounded-full group-hover:w-full transition-all duration-500`} />
            </div>
          </Reveal>
        ))}
      </div>

      {/* Tech Stack */}
      <Reveal from="up">
        <div className="glass rounded-2xl p-8 border border-brand-border mb-10">
          <h3 className="text-xl font-bold text-brand-text mb-6 text-center">Technology Stack</h3>
          <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 gap-3">
            {TECH_STACK.map((t, i) => (
              <div key={i} className="bg-brand-card rounded-xl p-3 text-center border border-brand-border hover:border-brand-blue/30 hover:bg-brand-blue/5 transition-all duration-200 group cursor-default">
                <div className="text-brand-text font-semibold text-sm group-hover:text-brand-blue transition-colors">{t.name}</div>
                <div className="text-brand-dim text-xs mt-0.5">{t.cat}</div>
              </div>
            ))}
          </div>
        </div>
      </Reveal>

      {/* Trust pillars */}
      <Reveal from="up">
        <div className="bg-gradient-to-r from-brand-blue/10 via-brand-purple/5 to-brand-green/10 rounded-2xl p-8 border border-brand-border text-center">
          <h3 className="text-2xl font-bold text-brand-text mb-8">Trusted by Forward-Thinking Businesses</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[
              { icon: '🏆', title: 'Quality Assured', desc: 'Rigorous testing and QA at every stage of development.' },
              { icon: '⏱️', title: 'On-Time Delivery', desc: 'Consistent track record of meeting deadlines and commitments.' },
              { icon: '💼', title: 'Business Value', desc: 'Solutions engineered for measurable, real-world business outcomes.' },
            ].map((p, i) => (
              <div key={i} className="space-y-3">
                <div className="text-4xl">{p.icon}</div>
                <h4 className="text-brand-text font-bold">{p.title}</h4>
                <p className="text-brand-muted text-sm">{p.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);

export default WhyChoose;
